import { render, staticRenderFns } from "./CompareActionsComponent.vue?vue&type=template&id=59c52961"
import script from "./CompareActionsComponent.vue?vue&type=script&lang=js"
export * from "./CompareActionsComponent.vue?vue&type=script&lang=js"
import style0 from "./CompareActionsComponent.vue?vue&type=style&index=0&id=59c52961&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports